import {HeaderNavbarRightContainerDefaultBox} from "./header-navbar-right-container.default.box";

export const HeaderNavbarRightContainerBox = HeaderNavbarRightContainerDefaultBox;
